<template>
  <div class="kpi-group-details">
    <div class="group-header">
      <div class="category-indicator"></div>
      <h4 class="group-title">{{ group.label }}</h4>
    </div>

    <div class="group-kpis">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiGroupDetails',

  props: {
    group: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-group-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-indicator {
  width: 2px;
  height: 16px;
  background: var(--bmw-primary);
  border-radius: 2px;
}

.group-title {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin: 0;
}

.group-kpis {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 8px;
}

// Dark Mode
:root.dark,
[data-bs-theme="dark"] {
  .group-title {
    color: var(--color-foreground);
  }
}
</style>
